import { Store, Module, ActionContext } from "vuex";
import ListModule from "./list-module";
import ListState from "./list-state";
import Address from "../entities/address";
import ProvinceForSelect from "../entities/provinceForSelect";
import Ajax from "../../lib/ajax";

interface GeoLocationState extends ListState<Address> {
  provincesForSelect: ProvinceForSelect[];
}
class GeoLocationModule extends ListModule<GeoLocationState, any, Address> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<Address>(),
    loading: false,
    provincesForSelect: new Array<ProvinceForSelect>(),
  };
  actions = {
    async getProvincesForSelect(context: ActionContext<GeoLocationState, any>) {
      let reponse = await Ajax.get("/api/services/app/GeoLocation/provinces");
      context.state.provincesForSelect = reponse.data.result
        .items as ProvinceForSelect[];
    },
    async getDistrictsForSelectOfProvince(
      context: ActionContext<GeoLocationState, any>,
      payload: any,
    ) {
      let reponse = await Ajax.get(
        `/api/services/app/GeoLocation/${payload.data.provinceId}/districts`,
      );
      return reponse.data.result.items;
    },
    // async getWardsForSelectOfDistrict(context: ActionContext<GeoLocationState, any>, payload: any) {
    //     let reponse = await Ajax.get(`/api/services/app/GeoLocation/${payload.data.districtId}/wards`);
    //     return reponse.data.result.items;
    // },
    async getWardsForSelectOfProvince(
      context: ActionContext<GeoLocationState, any>,
      payload: any,
    ) {
      let reponse = await Ajax.get(
        `/api/services/app/GeoLocation/${payload.data.provinceId}/wards`,
      );
      return reponse.data.result.items;
    },
  };
  mutations = {
    setCurrentPage(state: GeoLocationState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: GeoLocationState, pagesize: number) {
      state.pageSize = pagesize;
    },
  };
}
const geoLocationModule = new GeoLocationModule();
export default geoLocationModule;
